import { useEffect, useState } from 'react'
import style from './geral.module.css'
import { filtro, getDocCollection, getDocumentoUnico } from '../../../firebase/CRUD'
import { FichaAula, FichaRelatorio } from '../../layout/Fichas'
import LinkButton from '../../layout/LinkButton'
import { useAuth } from '../../../hooks/AuthContext'
import Dashboard from '../../layout/Dashboard/Dashboard'
export default function Geral(){
    const {usuario} = useAuth()
    const [aulas,setAulas]= useState()
    const [alunos,setAlunos] = useState()
    useEffect(()=>{
        // getDocCollection("aulaTurma",setAulas)
        // getDocCollection('alunos',setAlunos,usuario.idEscola)
    },[])

    console.log(alunos)
    return(
        <section className={`${style.container}`}>
            <h3>Relatorios e estatísticas</h3>
                <Dashboard escolaId={usuario.idEscola}/>
                <section>
                    <h2>Relatorios</h2>
                    <div style={{display:"flex",width:"100%",justifyContent:"center"}}>
                        <LinkButton text={"Gerar relatório mensal"} to={"/relatoriomensal"}/>
                    </div>
                    <div style={{display:"flex",width:"100%",justifyContent:"center"}}>
                        <LinkButton text={"Histórico de relatórios mensais"} to={"/historico-relatorios"}/>
                    </div>
                    <div className={`${style.geralList}`}>
                        {aulas && 
                            aulas.map((item)=>{
                                <div>
                                    <p>{item}</p>
                                </div>
                               
                            })
                        }
                    </div>
                </section>
        </section>
    )
}